import type { CanActivateFn } from '@angular/router';
import { environment } from 'src/environments/environment';

export const testGuard: CanActivateFn = () => {
  if(environment.production) return false;

  return true;
};
